{
    "expo": {
        "name": "vetir-web",
        "slug": "vetir-web",
        "version": "1.0.0",
        "orientation": "portrait",
        "icon": "./assets/images/icon.png",
        "scheme": "myapp",
        "userInterfaceStyle": "automatic",
        "splash": {
            "image": "./assets/images/splash.png",
            "resizeMode": "contain",
            "backgroundColor": "#ffffff"
        },
        "ios": {
            "supportsTablet": true
        },
        "android": {
            "adaptiveIcon": {
                "foregroundImage": "./assets/images/adaptive-icon.png",
                "backgroundColor": "#ffffff"
            }
        },
        "web": {
            "bundler": "metro",
            "output": "static",
            "favicon": "./src/assets/vetir_logo.png"
        },
        "plugins": [
            "expo-router",
            [
                "@sentry/react-native/expo",
                {
                    "organization": "vetir",
                    "project": "vetir-website",
                    "url": "https://sentry.io/"
                }
            ],
            "expo-video"
        ],
        "experiments": {
            "typedRoutes": true
        }
    }
}
